<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div>
        <vs-select class="w-full" autocomplete v-model="disaster" @change="change" :disabled="readonly">
          <vs-select-item v-for="(disaster, index) in disasterList" :key="index" :text="disaster.text || disaster.value" :value="disaster.value" />
        </vs-select>
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="!label" :columns="options['gridTemplateColumns']">
      <div>
        <vs-select class="w-full xl:w-32" autocomplete v-model="disaster" @change="change" :disabled="readonly">
          <vs-select-item v-for="(disaster, index) in disasterList" :key="index" :text="disaster.text || disaster.value" :value="disaster.value" />
        </vs-select>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import {valueDisasters} from "@/util/DisasterDataUtil";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchDisasterTypes",
  components: {
    SearchFilterItem,
    SearchLabelBody,
  },
  props: {
    label: {
      default: "재해형태",
      type: String,
    },
    value: String,
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          'dty': '',
        }
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      this.disaster = value;
    },
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    initData() {
      const defaultDisaster = this.options && this.options['default'] ? this.options['default'] : "";
      const _query_keys = Object.keys(this.query)
      const query = this.$route.query;
      const disaster = query[_query_keys[0]];
      if (disaster) {
        try {
          return {
            disaster: disaster || defaultDisaster,
          };
        } catch (e) {}
      }

      return {
        disaster: defaultDisaster,
      };
    },
    disasterList() {
      return [
        {
          text: '전체선택',
          value: ''
        }, ...valueDisasters()
      ];
    },
  },
  data() {
    return {
      disaster: "",
    };
  },
  created() {
    this.disaster = this.initData.disaster;
    this.$emit("input", this.disaster);
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    change(data) {
      this.$emit("input", data);
    },
    onClickFilterRemove () {
      this.disaster = '';
      this.$emit("input", this.disaster);
    }
  },
};
</script>
